// extracted by mini-css-extract-plugin
export default {"melodyVideo":"BL-z","isFullWidth":"CL-z","landingPageVideo":"DL-z","play":"EL-z","iframeVideo":"FL-z","playHidden":"GL-z","fullwidth":"HL-z"};